import { ThemeConsumer, ThemeContext } from 'styled-components/native';

export {
  ThemeConsumer as NativeBaseConsumer,
  ThemeContext as NativeBaseContext,
};
